import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Tooltip, Button, message } from "antd"
import { getOrderForPackaging, markOrderPackaged, markCompletedByOrderIdV2 } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import MarkPackagedPageSpecifications from './MarkPackagedPageSpecifications'
import MarkPackagedPageDetails from './MarkPackagedPageDetails'
import convertDateOverTime from '../../../helpers/convertDateOverTime'
import printImage from "../../../helpers/printQRCode/printImage"
import drawLabel from "../../../helpers/printQRCode/drawLabel"
import releaseBasket from '../../merger-v2/actions/releaseBasket'
import ListTypeAllowNotPrintQr from '../heplers/ListTypeNotAllowPrintQr'

function MarkPackagedPage() {
    const _input = useRef()
    const textRef = useRef()
    const [loading, setLoadingState] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [loadingMessage, setLoadingMessage] = useState('Loading...')
    const [actionMessage, setActionMessage] = useState('')
    const [actionMessageType, setActionMessageType] = useState('error')
    const [processingOrder, setProcessingOrder] = useState('')
    const [orders, setOrders] = useState('')
    const [totalItems, setTotalItems] = useState(0)
    const [isMask, setIsMask] = useState(false)
    const [sku, setSku] = useState({})
    const [skuSizes, setSkuSizes] = useState({})
    const [tags, setTags] = useState([])
    const [isMoreThanTwoLines, setIsMoreThanTwoLines] = useState(false)
    const [isMarkPackageOneItem, setIsMarkPackageOneItem] = useState(false)
    const [itemNeedNamePrintQr, setItemNameNeedPrintQr] = useState({})
    const [loadingQC, setLoadingQC] = useState(false)
    const [basket, setBasket] = useState({})
    const [setItems, setSetItems] = useState([])

    const checkTextHeight = () => {
        if (!!textRef.current) {
            const lineHeight = parseFloat(
                window.getComputedStyle(textRef.current).lineHeight
            )
            const maxHeight = lineHeight * 2
            setIsMoreThanTwoLines(textRef.current.scrollHeight > maxHeight)
        }
    }

    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
    const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isComboSock = Array.isArray(tags) && tags.includes('combo_socks')
    const isNoProofTag = Array.isArray(tags) && tags.includes('no_proof')
    const is24hTag = Array.isArray(tags) && tags.includes('24h')

    const setMessage = (msg, type = 'error') => {
        setActionMessage(msg)
        setActionMessageType(type)
    }

    const setLoading = (loading, msg = 'Loading...') => {
        setLoadingState(loading)
        loading && msg && setLoadingMessage(msg)
    }

    const formatMessage = (message) => {
        let vMessage = message && message.replace(/(\d+_\d+)/g, '<strong>$1</strong> ')
        vMessage && (vMessage = <div dangerouslySetInnerHTML={{ __html: vMessage }} />)

        return vMessage
    }

    const getOrder = async (barcodeStr) => {
        setLoading(true, <>Đang lấy thông tin đơn #{barcodeStr}...</>)
        setMessage('')
        const response = await getOrderForPackaging({ barcodeStr, get_basket: true }).catch(e => {
            return {
                error: e.message
            }
        })
        
        const { data, success, error: message } = response
        const { processingOrder, totalItems, orders, isMask, sku: Sku, skuSizes = {}, basket = {} } = { ...(data || {}) }
        const { barcode, meta = {} } = { ...processingOrder }
        const { set_items = [] } = meta || {}
        const { tags: listTags } = { ...barcode }

        if (!processingOrder || !success) {
            const vMessage = formatMessage(message)

            setMessage(vMessage || `Không tìm thấy mã đơn #${barcodeStr}`)
            _resetScanInput(false)
            return Modal.error({
                title: 'Lỗi',
                content: vMessage || `Không tìm thấy mã đơn #${barcodeStr}`,
                //onOk: _resetScanInput(),
                okText: 'Đóng',
            })
        }

        setProcessingOrder(processingOrder)
        setSku(Sku)
        setSkuSizes(skuSizes)
        setOrders(orders)
        setTotalItems(totalItems)
        setIsMask(isMask)
        setTags(listTags)
        setSetItems(set_items)
        if (!!basket && !!Object.keys(basket).length) setBasket(basket)
    }

    const _onSubmit = async (e) => {
        e && e.preventDefault()
        setIsMoreThanTwoLines(false)

        if (!valueInput || !`${valueInput}`.length) {
            return setMessage('Nhập vào mã đơn.')
        }

        reset(false)


        const checkValue = /^#\d+_\d+$/.test(valueInput)

        if (!checkValue || !valueInput.trim()) {
            const msg = <>Sai định dạng mã đơn, nhập
                đúng <strong>123456_1</strong> hoặc <strong>#123456_1</strong></>
            setMessage(msg)
            setLoading(false)

            return false
        }

        try {
            await getOrder(valueInput.replace(/^#/, ''))
            checkTextHeight()
        } catch (error) {
            setMessage(error)
        } finally {
            setLoading(false)
        }
    }

    const _resetScanInput = (focus = true) => {
        setValueInput('')
        focus && focusInput()
    }

    const focusInput = () => {
        setTimeout(() => {
            _input.current && _input.current.focus()
        }, 300)
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setMessage('')
    }

    const checkArrayIsMarkPackageOneItem = (arr = []) => {
        if (arr.length !== 2) return false

        const hasSpecialType = arr.some(item => item.type === "THANK_CARD" || item.type === "BRAND_KIT")
        const hasOtherType = arr.some(item => item.type !== "THANK_CARD" && item.type !== "BRAND_KIT")

        return hasSpecialType && hasOtherType
    }

    const handleMarkPackaged = async () => {
        const { barcode = {}, type = '', pos } = Object.assign({}, processingOrder)
        setLoading(true, <>Đang gửi yêu cầu đánh dấu đơn #{barcodeStr} đã đóng gói...</>)

        const ip_local = sessionStorage.getItem("lanIp")
        const payload = { ip_local }
        if (Array.isArray(setItems) && !!setItems.length && !!pos) payload.set_items = { [pos]: Object.fromEntries(setItems.map(item => [item._id, item])) }
        try {
            const { success, error, data } = await markOrderPackaged(barcodeStr, payload)

            if (!success) {
                throw new Error(error)
            }

            let {
                message
            } = { ...data }

            if (message) {
                message = formatMessage(message)
            }

            setMessage(message || <>Đơn <strong>#{barcodeStr}</strong> đã được đánh dấu đóng gói thành công.</>, '')
            // reset()

            const { products = [], } = { ...barcode }
            if (checkArrayIsMarkPackageOneItem(products) && !ListTypeAllowNotPrintQr.includes(type)) {
                const itemBrandKitThankCard = products.find(p => p.type === "THANK_CARD" || p.type === "BRAND_KIT") || {}
                setIsMarkPackageOneItem(true)
                if (Object.keys(itemBrandKitThankCard).length > 0) setItemNameNeedPrintQr(itemBrandKitThankCard)
            } else {
                reset()
            }

        } catch (error) {
            setMessage(error.message)
        } finally {
            setLoading(false)
            focusInput()
        }
    }

    const reset = (resetInput = true) => {
        resetInput && _resetScanInput()
        setIsMask(false)
        setTotalItems(0)
        setOrders(false)
        setProcessingOrder(false)
        // setMessage('')
        setTags([])
        setIsMarkPackageOneItem(false)
        setBasket({})
    }

    const _handleInputKeyDown = (e) => {
        if (e.keyCode === 13) {

        } else if (e.keyCode === 27) {

        }
    }

    const onCancel = () => {
        focusInput()
    }

    const _parseInfo = (info, basket, totalItems) => {
        const { barcode_number, size, type } = Object.assign({}, info)
        const orderId = !!itemNeedNamePrintQr.pos ? `#${barcode_number}_${itemNeedNamePrintQr.pos}` : `#${barcode_number}`

        return {
            orderId,
            type,
            size,
            basket: !!basket ? basket : null,
            total: !!totalItems ? totalItems : null,
        }
    }

    const handlePrintQR = async () => {
        setLoadingQC(true)
        try {
            const payload = {
                ignore_basket: !!Object.keys(basket).length ? false : true
            }
            const { brandKit = [], thankCard = [] } = { ...processingOrder }

            const listIdBrandKit = brandKit.map(bk => !!bk.order3D && bk.order3D).filter(Boolean) || []
            const listIdThankCard = thankCard.map(tk => !!tk.order3D && tk.order3D).filter(Boolean) || []

            if (!!listIdBrandKit.length || !!listIdThankCard.length) payload.order_ids = [...new Set([...listIdThankCard, ...listIdBrandKit])]

            const { data: response } = await markCompletedByOrderIdV2(payload)
            const { success, data, error } = response

            if (!success) throw new Error(error)

            const { successOrders = [], failedOrders = [] } = data

            if (!!failedOrders.length) {
                const { message: messError } = !!failedOrders[0] ? failedOrders[0] : {}
                return message.error(messError)
            }


            if (!!Object.keys(basket).length) {
                const { _id } = { ...basket }
                if (!!_id) await releaseBasket(_id)
            }

            const { order } = !!successOrders[0] ? successOrders[0] : {}
            if (!!itemNeedNamePrintQr.pos) {
                await drawLabel(_parseInfo(order, null, null)).then(r => printImage(r))
            }
            reset()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoadingQC(false)
        }
    }

    const barcodeStr = processingOrder && [processingOrder.barcode_number, processingOrder.item_number].join('_')

    // window.addEventListener('load', () => {
    //     console.log({_input})
    //     setTimeout(() => {
    //         _input && _input.current && _input.current.focus()
    //         _onSubmit()
    //     }, 1000)
    // })

    window.onfocus = function () {
        focusInput()
    }

    const { barcode, brandKit = [], thankCard = [], type } = { ...processingOrder }
    const { storename, note: noteOrder = '', barcodeNumber = '', tags: barcodeTags = [] } = { ...(barcode || {}) }
    const CAPTYPES = ['SNAP_CAP_13', 'TRUCKER_CAP_13', 'BASEBALL_CAP_13', 'EMBROIDERED_CAP']
    const isCapTag = Array.isArray(barcodeTags) && barcodeTags.includes('cap_product') && CAPTYPES.includes(type)
    const isSLL = Array.isArray(barcodeTags) && barcodeTags.includes('SLL')

    return (
        <div className="MarkPackagedPage py-5">
            <div className="col-12 mx-auto px-5">
                <div className="row align-items-baseline justify-content-between position-relative">
                    <div className='col-8 d-flex justify-content-between align-items-center' style={{ marginBottom: '20px' }}>
                        <h1 className="PageTitle mb-0 d-flex align-items-center flex-wrap">
                            <span className='mr-4' >Đánh dấu đóng gói</span>
                            <div className="d-flex flex-wrap align-items-center Fastproduction position-relative" >
                                {
                                    isCapTag &&
                                    <span className="mt-2 cap-tag mr-2 mb-0">Sản phẩm Mũ</span>
                                }
                                {
                                    isSLL &&
                                    <span className="mt-2 SLL-tag mr-2 mb-0">SLL</span>
                                }
                                {
                                    isComboSock &&
                                    <span className='mt-2 tag-fast mr-3 mb-1'>COMBO SOCKS</span>
                                }
                            </div>
                        </h1>
                        {processingOrder && !!processingOrder.overtime && processingOrder.overtime > 0 &&
                            <div>
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: 'rgba(255 77 80)',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    QUÁ HẠN <label
                                        className="font-weight-bold my-0">{convertDateOverTime(processingOrder.overtime)}</label>
                                </h4>
                            </div>
                        }
                        {!!processingOrder && !!processingOrder.remaining_time && (processingOrder.remaining_time > 0 && processingOrder.remaining_time <= 1.5) &&
                            <div>
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: '#ffcd3a',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    Sắp quá hạn <label
                                        className="font-weight-bold my-0">{convertDateOverTime(-processingOrder.remaining_time)}</label>
                                </h4>
                            </div>
                        }
                    </div>
                    <div className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6 position-absolute" style={{ zIndex: 2, right: 0, top: -40 }}>
                        <NavLink exact to="/packing-item" className="nav-link p-0">
                            Danh sách đóng gói
                        </NavLink>
                    </div>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateOrderPackaged">
                        <div className="UpdateOrderPackagedPage">
                            <div className="position-relative">
                                <Spin spinning={loading} tip={loadingMessage}>
                                    <form onSubmit={_onSubmit} className="mb-4 row">
                                        <div className="col-md-8">
                                            <div className="Input">
                                                <Input
                                                    value={valueInput.toUpperCase()}
                                                    style={{ fontSize: 36, height: "auto" }}
                                                    ref={_input}
                                                    autoFocus={true}
                                                    placeholder="Nhập item cần đánh dấu"
                                                    onChange={_handleChangeScan}
                                                    onKeyDown={_handleInputKeyDown}
                                                />

                                                {
                                                    valueInput && !loading &&
                                                    <Icon
                                                        type="close-circle"
                                                        className="position-absolute cursor-pointer text-dark IconInput"
                                                        onClick={_resetScanInput}
                                                    />
                                                }

                                                {
                                                    loading &&
                                                    <Icon type="sync" spin className="position-absolute IconInput" />
                                                }

                                            </div>

                                            {
                                                actionMessage && <div className={
                                                    actionMessageType === 'error'
                                                        ? 'ErrorMsg alert alert-danger'
                                                        : 'SuccessMsg alert alert-success'
                                                }>{actionMessage}</div>
                                            }

                                            {
                                                !!processingOrder && !!orders &&
                                                <MarkPackagedPageDetails
                                                    processingOrder={processingOrder}
                                                    sku={sku}
                                                    totalItems={totalItems} orders={orders}
                                                    isMask={isMask}
                                                    loadging={loading}
                                                    reset={reset}
                                                    onMarkPackaged={handleMarkPackaged}
                                                    onCancel={onCancel}
                                                />
                                            }

                                            {
                                                isMarkPackageOneItem &&
                                                <Modal
                                                    title={<span className='h1'>{`#${barcodeNumber}_${itemNeedNamePrintQr.pos ? itemNeedNamePrintQr.pos : 2}`}</span>}
                                                    onOk={handlePrintQR}
                                                    onCancel={() => {
                                                        setIsMarkPackageOneItem(false)
                                                        reset()
                                                    }}
                                                    visible={isMarkPackageOneItem}
                                                    footer={[
                                                        <Button type="primary" onClick={handlePrintQR} loading={loadingQC}>In QR</Button>
                                                    ]}
                                                >
                                                    <div className="custom-modal-print-qr d-flex justify-content-center algin-items-center">
                                                        {
                                                            thankCard.map(order => {
                                                                return <div className="Block ThankCardBlock" key={order._id}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <div className="ColContent">
                                                                            <div className={['PreviewPrinting'].filter(Boolean).join(' ')}>
                                                                                <img
                                                                                    src={order.preview_image}
                                                                                    alt='preview'
                                                                                    style={{
                                                                                        maxHeight: 500,
                                                                                        objectFit: 'contain'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            })
                                                        }

                                                        {
                                                            brandKit.map(order => {
                                                                return <div className="Block ThankCardBlock" key={order._id}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <div className="ColContent">
                                                                            <div className={['PreviewPrinting'].filter(Boolean).join(' ')}>
                                                                                <img
                                                                                    src={order.preview_image}
                                                                                    alt='preview'
                                                                                    style={{
                                                                                        maxHeight: 500,
                                                                                        objectFit: 'contain'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                </Modal>
                                            }
                                        </div>
                                        <div className="col-md-4 position-relative">
                                            <div
                                                className="d-flex Fastproduction w-100"
                                                style={{ top: -60, overflowX: 'auto' }}
                                            >
                                                {
                                                    isTikTokTag &&
                                                    <span className='mr-2 mb-1 tiktok'>TIKTOK</span>
                                                }
                                                {
                                                    is24hTag &&
                                                    <span className='mr-2 mb-1 tiktok'>24h</span>
                                                }
                                                {
                                                    isFastProductionTag &&
                                                    <span className='tag-fast mr-2 mb-1'>Sản xuất nhanh</span>
                                                }
                                                {
                                                    isCutoffTag &&
                                                    <span className='mr-2 mb-1'>Cutoff</span>
                                                }
                                                {
                                                    isCutOffNoel &&
                                                    <span className='mr-2 mb-1'>Cutoff noel</span>
                                                }
                                                {
                                                    isCutOffNewYear &&
                                                    <span className='mb-1'>Cutoff new year</span>
                                                }
                                            </div>
                                            {
                                                storename === 'mt80szd' &&
                                                <h2 className='text-danger'>Sản phẩm VIP - QC, đóng gói tách riêng</h2>
                                            }
                                            {
                                                !!noteOrder &&
                                                <h1
                                                    className='text-danger mr-3 position-absolute'
                                                    ref={textRef}
                                                    style={{
                                                        fontSize: '25px',
                                                        cursor: isMoreThanTwoLines ? 'pointer' : 'unset',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    {
                                                        isMoreThanTwoLines ?
                                                            <Tooltip title={noteOrder}>
                                                                Note: {`${noteOrder.slice(0, 40)}...`}
                                                            </Tooltip> :
                                                            `Note: ${noteOrder}`
                                                    }
                                                </h1>
                                            }
                                            {
                                                !!processingOrder &&
                                                <MarkPackagedPageSpecifications
                                                    sku={sku}
                                                    isMoreTag={storename === 'mt80szd'}
                                                    orders={orders}
                                                    isMask={isMask}
                                                    skuSizes={skuSizes}
                                                    noteOrder={noteOrder}
                                                    totalItems={totalItems}
                                                    processingOrder={processingOrder}
                                                />
                                            }
                                        </div>
                                    </form>
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarkPackagedPage